import React from 'react'
import { LanguageContextProvider } from './languages/language'
import { GlobalStyle } from './styles/global'
import Routes from 'routes'
import {} from './types'
import { ThemeContextProvider, useTheme } from './styles/colors'

const AppContent = () => {
  const { colors } = useTheme()

  return (
    <>
      <GlobalStyle $colors={colors} />
      <Routes />
    </>
  )
}
const App: React.FC = () => {
  return (
    <LanguageContextProvider>
      <ThemeContextProvider>
        <AppContent />
      </ThemeContextProvider>
    </LanguageContextProvider>
  )
}

export default App
